import axios from "axios";
import React, { createContext, useContext, useMemo, useState } from "react";

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, USERNAME_KEY } from "../lib/api";

const API_URL = process.env.REACT_APP_API_URL;

interface AuthContextValue {
  username: string | null;
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [username, setUsername] = useState<string | null>(() =>
    localStorage.getItem(USERNAME_KEY)
  );

  const login = async (usernameInput: string, password: string) => {
    const response = await axios.post<{ access: string; refresh: string }>(
      `${API_URL}/token/`,
      { username: usernameInput, password }
    );
    localStorage.setItem(ACCESS_TOKEN_KEY, response.data.access);
    localStorage.setItem(REFRESH_TOKEN_KEY, response.data.refresh);
    localStorage.setItem(USERNAME_KEY, usernameInput);
    setUsername(usernameInput);
  };

  const logout = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
    setUsername(null);
  };

  const value = useMemo<AuthContextValue>(
    () => ({
      username,
      isAuthenticated: username !== null,
      login,
      logout,
    }),
    [username]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
}
